import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "dialog-custom__header" }
const _hoisted_2 = { class: "dialog-custom__title" }
const _hoisted_3 = { class: "dialog-custom__content form-custom" }
const _hoisted_4 = {
  class: "dialog-plant-create__grid--even",
  style: {"gap":"2rem"}
}
const _hoisted_5 = {
  key: 0,
  style: {"height":"calc(100vh - 300px)"}
}
const _hoisted_6 = { class: "px-3 py-1" }
const _hoisted_7 = { class: "p-field-label my-2" }
const _hoisted_8 = { style: {"margin":"0 -0.5rem"} }
const _hoisted_9 = {
  class: "checkbox-sublabel text-gray",
  style: {"font-size":"13px"}
}
const _hoisted_10 = {
  key: 1,
  style: {"height":"calc(100vh - 300px)"}
}
const _hoisted_11 = { class: "mb-4" }
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = { class: "d-flex mb-3" }
const _hoisted_14 = { class: "text-gray" }
const _hoisted_15 = { class: "ml-auto" }
const _hoisted_16 = { class: "text-uppercase text-gray small" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_ListItemCheck = _resolveComponent("ListItemCheck")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", _hoisted_1, [
      _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.pageTitle), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        (_ctx.currentBuilding)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode(_component_ElScrollbar, { class: "dialog-scroll" }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_6, [
                    _createVNode("label", {
                      class: "p-field-label mt-1",
                      for: `buildingName${_ctx.currentBuildingIndex}`
                    }, _toDisplayString(_ctx.$t("NameBuilding")) + " " + _toDisplayString(_ctx.currentBuildingIndex + 1), 9, ["for"]),
                    _createVNode(_component_InputText, {
                      id: `buildingName${_ctx.currentBuildingIndex}`,
                      type: "text",
                      modelValue: _ctx.currentBuilding.name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentBuilding.name = $event)),
                      class: "mb-3"
                    }, null, 8, ["id", "modelValue"]),
                    _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("AppResourceEP.AssociateRisersBackboneWithBuilding")), 1),
                    _createVNode("div", _hoisted_8, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availableRiserOptions, (riserOption, index) => {
                        return (_openBlock(), _createBlock(_component_ListItemCheck, {
                          key: riserOption.riserId,
                          label: riserOption.riserName,
                          value: riserOption.riserId,
                          disabled: _ctx.isRiserDisabledForBuilding(_ctx.currentBuildingIndex, riserOption.riserId),
                          inputId: `building${_ctx.currentBuildingIndex}Riser${riserOption.riserId}`,
                          name: "riserLinkSelection",
                          modelValue: _ctx.currentBuilding.linkedRisersIds,
                          "onUpdate:modelValue": [
                            _cache[2] || (_cache[2] = ($event: any) => (_ctx.currentBuilding.linkedRisersIds = $event)),
                            ($event: any) => (_ctx.toggleRiserLink(_ctx.currentBuildingIndex, riserOption.riserId))
                          ],
                          last: index == _ctx.availableRiserOptions.length-1
                        }, _createSlots({ _: 2 }, [
                          (riserOption.interfacesComboMode !== '')
                            ? {
                                name: "checkbox-sublabel",
                                fn: _withCtx(() => [
                                  _createVNode("div", _hoisted_9, [
                                    _createVNode("small", null, _toDisplayString(riserOption.interfacesComboMode), 1)
                                  ])
                                ])
                              }
                            : undefined
                        ]), 1032, ["label", "value", "disabled", "inputId", "modelValue", "onUpdate:modelValue", "last"]))
                      }), 128))
                    ])
                  ])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.currentBuilding && _ctx.currentBuilding.linkedRisersConfig.length > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_10, [
              _createVNode(_component_ElScrollbar, { class: "dialog-scroll" }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_11, [
                    _createVNode("h6", _hoisted_12, _toDisplayString(_ctx.currentBuilding.name), 1),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.currentBuilding.linkedRisersConfig, (riser, riserId) => {
                      return (_openBlock(), _createBlock("div", { key: riserId }, [
                        _createVNode("div", _hoisted_13, [
                          _createVNode("div", _hoisted_14, _toDisplayString(riser.name), 1),
                          _createVNode("div", _hoisted_15, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(riser.interfaces, (intf, intfIndex) => {
                              return (_openBlock(), _createBlock("div", {
                                key: intfIndex,
                                class: "mb-3 d-flex flex-column"
                              }, [
                                _createVNode("label", _hoisted_16, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('AppResourceEP.Apartments')), 1),
                                  (!riser.isBackbone)
                                    ? (_openBlock(), _createBlock("span", _hoisted_17, " (" + _toDisplayString(_ctx.getInterfaceModeLabel(intf.mode)) + ")", 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode(_component_InputText, {
                                  modelValue: intf.numberOfApartments,
                                  disabled: true,
                                  class: "w-100"
                                }, null, 8, ["modelValue"])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("footer", _hoisted_18, [
      _createVNode(_component_Button, {
        onClick: _ctx.handleBackButton,
        label: _ctx.$t('AppResource.Back'),
        class: "p-button-text mr-3"
      }, null, 8, ["onClick", "label"]),
      _createVNode(_component_Button, {
        onClick: _ctx.handleNextButton,
        disabled: _ctx.isNextDisabled,
        label: _ctx.nextButtonLabel,
        class: "p-button-rounded p-button-raised p-button--m"
      }, null, 8, ["onClick", "disabled", "label"])
    ])
  ], 64))
}